<template>
  <div class="popup-holder">
    <transition name="fade">
      <div
        v-if="showPopup"
        class="popup">
        <div
          ref="contentHolder"
          class="content">
          <div class="popup-image-holder">
            <img
              :src="imageSrc"
              class="popup-image">
          </div>
          <div class="headline-holder">
            <div class="title">{{ title }}</div>
            <span
              class="headline"
              v-html="headline" />
            <button
              :class="{ 'pulse-animation': !explanationVisible }"
              class="button-expand"
              @click="showExplanation">
              <img
                :src="require(`@/assets/img/arrow.svg`)"
                class="arrow">
            </button>
          </div>
          <transition name="expand">
            <div
              v-if="explanationVisible"
              class="explanation-holder">
              <span
                v-if="quote !== ''"
                class="quote">
                "{{ quote }}"
              </span>
              <span class="explanation">{{ explanation }}</span>
            </div>
          </transition>
          <button
            v-if="explanationVisible"
            :class="{ 'pulse-animation': explanationVisible }"
            class="button-close"
            @click="hidePopup">
            <img
              :src="require(`@/assets/img/close.svg`)"
              class="close">
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

// import TweetHeader from 'components/TweetHeader';

export default {
  components: {
    // TweetHeader,
  },
  props: {
    popups: {
      type: Array,
      default: () => [],
    },
    showPopup: {
      type: Boolean,
      default: false,
    },
    activeSection: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      enabled: false,
      imageSrc: '',
      title: '',
      headline: '',
      quote: '',
      explanation: '',
      explanationVisible: false,
    };
  },
  watch: {
    showPopup() {
      this.checkPopupContent();
    },
  },
  methods: {
    resetPopup() {
      this.explanationVisible = false;
    },
    checkPopupContent() {
      for (let i = 0; i < this.popups.length; i += 1) {
        if (this.popups[i].section === this.activeSection) {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          this.imageSrc = require(`assets/img/${this.popups[i].image}`);
          this.title = this.popups[i].title;
          this.headline = this.popups[i].headline;
          this.quote = this.popups[i].quote;
          this.explanation = this.popups[i].explanation;
          this.setShowPopupAnim();
        }
      }
    },
    hidePopup() {
      this.$emit('popup-hidden');
      this.resetPopup();
    },
    showExplanation() {
      this.explanationVisible = true;
    },
    setShowPopupAnim() {
      if (this.showPopup) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.contentHolder.classList.add('content-expanded');
          }, 10);
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,0.8);
    z-index: 19;
    @media screen and (max-width: 800px) and (orientation: landscape) {
      overflow: scroll;
    }
  }

  .popup-image-holder {
    width: 100%;
    position: absolute;
    height: 150px;
    top: -150px;
    text-align: center;

    @include tablet {
      height: 250px;
      top: -250px;
    }
  }

  .popup-image {
    height: 100%;
    vertical-align: bottom;
  }

  .content {
    transition: all 0.3s;
    width: 90%;
    max-width: 600px;
    height: auto;
    transform: scale(0.1,0.1);
    opacity: 0;
    position: relative;
  }

  .content-expanded {
    transform: scale(1,1);
    opacity: 1;
  }

  .button-expand {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px auto -46px;
    width: 30px;
    height: 30px;
    background-color: #FF6E6E;
    border-radius: 30px;
    border: none;
    color: white;
    cursor: pointer;
    outline: none;
  }
  .pulse-animation:before {
    display: block;
    height: 1px;
    width: 1px;
    position: absolute;
    left: 14px;
    top: 14px;
    border-radius: 50%;
    background-color: #FF6E6E;
    content: "";
    animation: pulse-anim 2s infinite;
  }
  .arrow {
    transform: rotate(90deg);
  }
  .title {
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    padding: 2px 10px;
    border-radius: 20px;
    color: white;
    background-color: black;
    white-space: nowrap;
  }

  .headline-holder {
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    padding: 10px 10px 30px;
    background-color: #FFF;
    justify-content: center;
    z-index: 7;
  }
  .headline {
    display: block;
    margin-top: 10px;
    line-height: 32px;
    font-size: 30px;
    font-weight: bold;
    padding: 10px;
    @include bigmobile {
      padding: 20px;
    }
  }

  .quote {
    display: block;
    margin-bottom: 10px;
    font-style: italic;
  }

  .explanation-holder {
    position: relative;
    width: 100%;
    max-height: 400px;
    margin: 0 auto;
    padding: 20px;
    background-color: #FFACAC;
    overflow: hidden;
    z-index: 6;
  }

  .button-close {
    margin: -13px auto 0;
    padding: 2px 0 0 0;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #FF6E6E;
    border-radius: 30px;
    font-size: 30px;
    border: none;
    color: white;
    z-index: 9;
    cursor: pointer;
    outline: none;
  }

  .close {
    width: 14px;
    height: 14px;
    position: relative;
  }

  .explanation {
    line-height: 18px;
  }

  @keyframes pulse-anim {
    0% {
      height: 1px;
      width: 1px;
      left: 15px;
      top: 15px;
      opacity: 1;
    }
    99% {
      opacity: 0;
      height: 60px;
      width: 60px;
      left: -15px;
      top: -15px;
    }
    100% {
      height: 1px;
      width: 1px;
      left: 15px;
      top: 15px;
      opacity: 0;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .expand-enter-active, .expand-leave-active {
    transition: max-height 1s, padding 0.5s;
  }
  .expand-enter, .expand-leave-to {
    max-height: 0;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupSection.vue